import { Component, inject, linkedSignal, model, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalDialogComponent } from '../../controls/components/advanced/modal-dialog/modal-dialog.component';
import { ButtonComponent } from '../../controls/components/basic/button/button.component';
import { ControlLabelComponent } from '../../controls/components/internal/control-label/control-label.component';
import { SingleselectboxComponent } from '../../controls/components/basic/singleselectbox/singleselectbox.component';
import { ButtonPrimaryDirective } from 'src/app/controls/directives/button-primary.directive';
import { ButtonSecondaryDirective } from 'src/app/controls/directives/button-secondary.directive';
import { Stakeholder } from 'src/app/stakeholder/models/stakeholder';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface TrackingChangeStakeholderModalResult {
  stakeholderId: number | null;
  comment: string;
}

@Component({
  imports: [ButtonComponent, ButtonPrimaryDirective, ButtonSecondaryDirective, ControlLabelComponent, FormsModule, ModalDialogComponent, SingleselectboxComponent],
  templateUrl: './tracking-change-stakeholder-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tracking-change-stakeholder-modal.component.scss'
})
export class TrackingChangeStakeholderModalComponent {
  private modal = inject(NgbActiveModal);

  stakeholders = model<Stakeholder[]>([]);
  selectedStakeholderId = model<number | null>(null);
  newSelectedStakeholderId = linkedSignal(() => this.selectedStakeholderId());
  comment = signal('');

  ok(): void {
    this.modal.close({
      stakeholderId: this.newSelectedStakeholderId(),
      comment: this.comment()
    } as TrackingChangeStakeholderModalResult);
  }

  cancel(): void {
    this.modal.dismiss();
  }
}
